const fancybox = document.querySelector('[data-fancybox]');

if (fancybox) {
	import('@fancyapps/ui')
		.then(({ Fancybox }) => {
			Fancybox.bind('[data-fancybox]', {});
		})
		.catch((err) => console.error(err));
}
